import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OverviewCard = React.memo(({ icon, image, iconBgClass, iconClass, value, title, description, valueClass, onClick, isActive, testId }) => {
        return (
                <div
                        data-testid={testId}
                        data-active={isActive ? 'true' : 'false'}
                        className={`rounded-2xl p-6 sm:p-8 transition-all duration-200 ${isActive ? 'bg-brand/5 shadow-xl' : 'bg-white shadow-md'
                                } ${onClick ? 'cursor-pointer hover:shadow-xl' : ''
                                }`}
                        onClick={onClick}
                >
                        <div className="flex items-start justify-between">
                                <div className="flex items-start">
                                        <div className={`w-12 h-12 ${iconBgClass} rounded-xl flex items-center justify-center mr-4`}>
                                                {image ? (
                                                        <img src={image} alt={title} className="w-8 h-8 object-contain" />
                                                ) : (
                                                        <FontAwesomeIcon icon={icon} className={`${iconClass} text-xl`} />
                                                )}
                                        </div>
                                        <div>
                                                <h3 className="font-semibold text-text-strong mb-1">{title}</h3>
                                                <p className="text-sm text-text-weak">{description}</p>
                                        </div>
                                </div>
                                <span data-testid="overview-value" className={`text-2xl font-bold ${valueClass}`}>{value}</span>
                        </div>
                </div>
        );
});

export default OverviewCard;
